export default theme => ({
  pastEvent: {
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.white.main} !important`,
    backgroundColor: theme.palette.disabled.light,
  },
  futureEvent: {
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.white.main} !important`,
    backgroundColor: theme.palette.purple.light,
  },
  activeEvent: {
    border: `1px solid ${theme.palette.white.main} !important`,
    backgroundColor: theme.palette.secondary.dark,
  },
});
